<app-web-loader *ngIf="isLoader"></app-web-loader>

<!-- Profile Section -->
<div id="my-profile-main-div">
    <div class="top-title-div">
        <h5 class="top-title">
            RESOURCE CENTER
            <button type="button" class="btn btn-sm btn-danger pull-right " (click)="showLogoutModel()">
                <i class="fas fa-power-off"></i>
            </button>
            <button type="button" class="btn btn-sm btn-danger pull-right resource-link">
                <i class="fas fa-cogs"></i>
            </button>
        </h5>
    </div>
</div>

<!-- Main Content Section -->
<div class="main-inner-div">
    <div class="card-body card-body-bg">
        <div class="section-container">
            <div class="section-box">
                <h3>Mobile Data Download</h3>
                <p>Curated Real Estate data of buyers, sellers, agents, and Real Estate businesses of Telangana and
                    Andhra Pradesh.</p>
                <a href="https://buyrentsale.com/assets/resource/TS_AP_Real_Data.pdf" download
                    class="btn btn-primary">Download</a>
            </div>
            <div class="section-box">
                <h3>Facebook Groups</h3>
                <p>Connect with like-minded individuals in our Facebook groups. Share insights, network, and stay
                    updated with the latest in real estate.</p>
                <a href="https://www.facebook.com/groups/your_facebook_group_link" target="_blank"
                    class="btn btn-primary">Download</a>
            </div>
            <div class="section-box">
                <h3>WhatsApp Groups</h3>
                <p>Join our WhatsApp groups to discuss real estate trends, opportunities, and updates. Stay connected
                    with professionals in the industry.</p>
                <a href="https://chat.whatsapp.com/your_whatsapp_group_link" target="_blank"
                    class="btn btn-primary">Download</a>
            </div>
            <div class="section-box">
                <h3>Telegram Groups</h3>
                <p>Join our curated Telegram groups to connect with real estate enthusiasts, agents, and professionals.
                    Get exclusive updates and network with industry insiders.</p>
                <a href="https://telegram.me/your_telegram_group_link" target="_blank"
                    class="btn btn-primary">Download</a>
            </div>

            <div class="section-box">
                <h3>Real Estate Trainers</h3>
                <p>Access valuable resources for real estate training and development. Elevate your skills and knowledge
                    in the industry.</p>
                <a href="https://buyrentsale.com/assets/resource/Real_Estate_Training.pdf" download
                    class="btn btn-primary">Download</a>
            </div>
            <div class="section-box">
                <h3>Real Estate Books</h3>
                <p>Explore curated real estate books to enhance your training and development. Elevate your skills and
                    knowledge in the industry.</p>
                <a href="https://buyrentsale.com/assets/resource/Books.zip" download
                    class="btn btn-primary">Download</a>
            </div>
            <div class="section-box">
                <h3>Real Estate Training Videos</h3>
                <p>Access valuable real estate training videos to enhance your skills and expertise. Learn from industry
                    experts and elevate your knowledge.</p>
                <a href="https://www.youtube.com/playlist?list=PLEKi4BmjWenE5AzClD5_rQwg0Dos7wZIw" download
                    class="btn btn-primary" target="_blank">Play</a>
            </div>
            <div class="section-box">
                <h3>Hash Tags</h3>
                <p>#realestate
                    #property
                    #sellproperty
                    #buyproperty
                    #Apartment
                    #grouphouse
                    #Independenthouse
                    #agriculturelands
                    #commerciallands
                    #approvedlayouts
                    #Redsandal
                    #srigandham
                    #resorts
                    #AndhraPradeshrealestate
                    #Telanganarealestate
                    #Realestateagents
                    #Amravatirealestate
                    #Vijayawadarealestate
                    #Realestatepromotions
                    #flats
                    #plots
                    #Malabarfarmland
                    #realty
                    #homes
                    #realtorlife
                    #brokerage
                    #listing
                    #greatvalue
                    #instarealestate
                    #instalisting
                    #Realtors
                    #NAR
                    #luxuryrealestate
                    #mansion
                    #HUDhome
                    #foreclosure
                    #househunting
                    #makememove
                    #luxuryliving
                    #homegoals
                    #housegoals
                    #investmentproperty
                    #emptynest
                    #broker
                    #realestateagent
                    #houseforsale
                    #homesforsale
                    #virtualtour
                    #luxurylistings
                    #justsold
                    #openhouse
                    #offmarketlistings
                    #pocketlisting
                    #newlisting
                    #homeforsale
                    #renovated
                    #marblecounters
                    #eatinkitchen
                    #motherinlawsuite
                    #petfriendly
                    #dogfriendly
                    #catfriendly
                    #condo
                    #coop
                    #twofamily
                    #midcenturymodern
                    #colonial
                    #Victorian
                    #bungalow
                    #shotgunshack
                    #starterhome
                    #cashcow
                    #caprate
                    #dreamhome
                    #fixandflip
                    #turnkeyinvestment
                    #curbappeal
                    #justsold
                    #selling
                    #townhouse
                    #brownstone
                    #frontporch
                    #parking
                    #pool
                    #yourbrokerage
                    #realestateexperts
                    #referrals
                    #yourpersonalbrand
                    #reducedfee
                    #discountbroker
                    #yourfarmarea + expert
                    #yourfarmarea + brokerage
                    #yourfarmarea + personalbranding
                    #realestateinvesting
                    #realestatenews
                    #luxuryhomes
                    #realestatedeveloper
                    #investmentopportunity
                    #realestateinvestor
                    #propertydevelopment</p>
                <p>
                    <a href="https://buyrentsale.com/m/searchproperty">2 BHK flats for sale in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">3 BHK flats for sale in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Flats for sale in Hyderabad between 50 Lacs to 10
                        Crores</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Apartments for sale in Hyderabad within 50 Lacs
                        to 10 Crores</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">2 BHK apartments for sale in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">3 BHK apartments for sale in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Houses for sale in Hyderabad between 50 Lacs to
                        10 Crores</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Real estate in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Open plots for sale in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Agricultural lands for sale in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Residential properties in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Affordable flats in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Luxury apartments in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Buy houses in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Hyderabad real estate deals</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Prime properties in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Hyderabad property market</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Property investment in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Best deals on flats in Hyderabad</a><br>
                    <a href="https://buyrentsale.com/m/searchproperty">Hyderabad real estate agents</a>
                </p>

            </div>
        </div>
    </div>
</div>

<!-- Logout Confirmation Modal -->
<div class="modal fade" id="LogoutModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Logout Confirmation</h5>
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to logout?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
                <button type="button" class="btn btn-danger" (click)="doLogout()">Yes</button>
            </div>
        </div>
    </div>
</div>